import { Injectable } from '@angular/core';
import {User} from "../definitions";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Subject} from "rxjs/Subject";
import {IDocument} from "../interfaces/document.definition";


@Injectable()
export class BusService {
  private documentUpdated: BehaviorSubject<INewDocumentEvent> = new BehaviorSubject(null);
  private documentSaved: Subject<boolean> = new Subject<boolean>();
  private _locksTimedOut: Subject<string[]> = new Subject<string[]>();
  private _texturePackerState: Subject<boolean> = new Subject<boolean>();
  private _preloaderIsVisible: Subject<boolean> = new Subject<boolean>();

  private documentLockRemovedSubject:Subject<string> = new Subject<string>();


  constructor() {
    this.emitDocumentUpdated({
      document: null,
      readonly: true,
      user: <any>{
        displayName: "system"
      }
    });
  }


  emitPreloaderIsVisible(isVisible: boolean) { this._preloaderIsVisible.next(isVisible); }
  emitLocksTimedOut(documentIds: string[]) { this._locksTimedOut.next(documentIds); }
  emitTexturePackerIsBusy(isBusy:boolean) { this._texturePackerState.next(isBusy); }

  /** @todo: rename me! */
  emitDocumentLockRemoved(documentId: string) { this.documentLockRemovedSubject.next(documentId); }
  emitDocumentUpdated(event: INewDocumentEvent) { this.documentUpdated.next(event); }
  emitDocumentSaved() { this.documentSaved.next(true); }



  get onPreloaderIsVisible() { return this._preloaderIsVisible.asObservable(); }
  get onTexturePackerIsBusy() { return this._texturePackerState.asObservable(); }
  get onLocksTimedOut() { return this._locksTimedOut.asObservable(); }
  get onDocumentUpdated() { return this.documentUpdated.asObservable(); }
  get onDocumentSaved() { return this.documentSaved.asObservable(); }
  get onDocumentLockRemoved() { return this.documentLockRemovedSubject.asObservable(); }
}


export interface INewDocumentEvent extends IEvent {
  document: IDocument,
  readonly: boolean,
  user: User
}


export interface IEvent {}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/bus.service.ts